import { render, staticRenderFns } from "./SendEmailButton.vue?vue&type=template&id=c38bb9be&scoped=true"
import script from "./SendEmailButton.vue?vue&type=script&lang=js"
export * from "./SendEmailButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38bb9be",
  null
  
)

export default component.exports